import SearchInputWrapper from './SearchInputWrapper';
import { SearchInput, StyledSearchIcon } from './styled';

export { SearchInput, StyledSearchIcon };

export default SearchInputWrapper;
